// ** Third Party Components
import PropTypes from "prop-types";

// ** Custom Components
import Block from "components/layout/Block";

// ** TableView Components
import TableHeader from "./components/TableHeader";
import TableRows from "./components/TableRows";
import TableActions from "./components/TableActions";
import CheckboxSelectAll from "./components/CheckboxSelectAll";
import CheckboxSelectRow from "./components/CheckboxSelectRow";

// ** Styled Components
import {
	StyledTable,
	StyledTableCell,
	StyledTableResponsiveContainer,
	StyledTableHeaderCell,
	StyledTableHead,
	StyledTableBody,
} from "./styles";

// #####################################################

const TableView = ({
	identityKey,
	responsiveType,
	data,
	columns,
	answerColumns,
	actions,
	customInput = null,
	customInputWidth = null,
	noModerate = false,
}) => {
	const headers = columns.map((column) => ({
		key: column.key,
		isMain: column.isMain || false,
		displayName: column.name,
		dataKey: column.dataKey,
		headerName: column.headerName,
		headerComponent: column.headerComponent,
		headerCellProps: { ...column.headerCellProps },
		rowComponent: column.rowComponent,
		showInMain: column.showInMain || false,
		priority: column.priority === undefined ? null : column.priority,
		rowCellProps: column.rowCellProps,
	}));

	const answerHeaders = answerColumns?.map((column) => ({
		key: column.key,
		isMain: column.isMain || false,
		displayName: column.name,
		dataKey: column.dataKey,
		headerName: column.headerName,
		headerComponent: column.headerComponent,
		headerCellProps: { ...column.headerCellProps },
		rowComponent: column.rowComponent,
		showInMain: column.showInMain || false,
		priority: column.priority === undefined ? null : column.priority,
		rowCellProps: column.rowCellProps,
	}));

	return (
		<>
			<StyledTableResponsiveContainer
				scrollable={responsiveType === "scroll"}
			>
				<StyledTable>
					<StyledTableHead>
						<TableHeader headers={headers} />
					</StyledTableHead>
					<StyledTableBody>
						<TableRows
							data={data}
							headers={headers}
							answerHeaders={answerHeaders}
							identityKey={identityKey}
							noModerate={noModerate}
						/>
					</StyledTableBody>
				</StyledTable>
			</StyledTableResponsiveContainer>
			{actions && (
				<Block flex flexWrap justifyStart mt={2}>
					<TableActions
						actions={actions}
						customInput={customInput}
						customInputWidth={customInputWidth}
					/>
				</Block>
			)}
		</>
	);
};

// #####################################################

TableView.CheckboxSelectAll = CheckboxSelectAll;
TableView.CheckboxSelectRow = CheckboxSelectRow;

TableView.TableHeaderCell = StyledTableHeaderCell;
TableView.TableCell = StyledTableCell;

TableView.defaultProps = {
	identityKey: "id",
	responsiveType: "scroll",
	toModerate: false,
};

TableView.propTypes = {
	identityKey: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
	responsiveType: PropTypes.oneOf(["scroll"]),
};

export default TableView;

// #####################################################
